import React from 'react';
import Logger from '../../../../../Utils/Logger';
import { getServerURL } from '../../../../../Utils/getServerURL';

interface IProps {
  simpleReload?: boolean;
  children: (handleLogout: () => void) => React.ReactNode;
}

export const getRootPath = (loc: string): string => {
  const hashIndex = loc.indexOf('#');
  if (hashIndex === -1) {
    return '/';
  }

  return loc.slice(0, hashIndex);
};

class LogoutHandler extends React.Component<IProps> {
  render() {
    const handleLogout = () => {
      fetch(`${getServerURL()}/logout`, {
        method: 'GET',
        credentials: 'include',
      })
        .then(res => {
          if (res.ok) {
            if (this.props.simpleReload) {
              location.reload();
            } else {
              // props.client.resetStore();
              location.replace(getRootPath(location.href));
            }
          } else {
            Logger.error(`Logout response not OK: ${res}`);
          }
        })
        .catch(err => {
          Logger.error(err);
        });
    };

    return this.props.children(handleLogout);
  }
}

export default LogoutHandler;
